var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8PauseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f58b00;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-pause-button",
    className: "cls-1",
    d: "M12,4a8,8,0,1,0,8,8A8.009,8.009,0,0,0,12,4Zm0,1.2A6.8,6.8,0,1,1,5.2,12,6.791,6.791,0,0,1,12,5.2ZM10,8.8a.8.8,0,0,0-.8.8v4.8a.8.8,0,1,0,1.6,0V9.6A.8.8,0,0,0,10,8.8Zm4,0a.8.8,0,0,0-.8.8v4.8a.8.8,0,1,0,1.6,0V9.6A.8.8,0,0,0,14,8.8Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PauseButton);
export default __webpack_public_path__ + "static/media/icons8-pause-button.260a0ab1a993e3174756108c20b719e5.svg";
export { ForwardRef as ReactComponent };